<app-header></app-header>
<app-toolbar></app-toolbar>
<ngx-ui-loader></ngx-ui-loader>
<div class="mainContent">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>